var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaquetePlantelMarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#BCA900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 21C18.4477 21 18 21.4477 18 22C18 22.5523 18.4477 23 19 23H23C23.5522 23 24 22.5523 24 22C24 21.4477 23.5522 21 23 21H19Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11C11.3431 11 10 12.3431 10 14V28C10 29.6569 11.3431 31 13 31H29C30.6569 31 32 29.6569 32 28V14C32 12.3431 30.6569 11 29 11H13ZM29 13H13C12.4477 13 12 13.4477 12 14V17H30V14C30 13.4477 29.5522 13 29 13ZM12 28V19H30V28C30 28.5523 29.5522 29 29 29H13C12.4477 29 12 28.5523 12 28Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaquetePlantelMarketplace);
export default __webpack_public_path__ + "static/media/paquetePlantelMarketplace.dd6947bd1b4bd6f629476ff7f9e1e5ec.svg";
export { ForwardRef as ReactComponent };